import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

export default function HandwrittenText({ text, delay = 0.03 }) {
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const letters = text.split("");
  const parts = text.match(/\w+|\s+|[^\s\w]+/g);

  return (
    <div
    ref={containerRef}
    className="font-bellefair text-lg md:text-xl text-center text-eryndra-forest leading-relaxed break-words"
  >
    {show &&
      parts.map((part, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * delay, duration: 0.2 }}
          className="inline-block"
        >
          {part === " " ? "\u00A0" : part}
        </motion.span>
      ))}
  </div>
  );
}
